export const SOCIAL_CALLBACK_URL = '/account';

export const SOCIAL_OAUTH_RESPONSE_TYPE = 'code';

export const SOCIAL_QUERY_CONNECT = 'connect';

export const SOCIAL_QUERY_DISCONNECT = 'disconnect';

export const enum SocialCallbackQueryParams {
    STATE = 'state',
    CODE = 'code',
    ERROR = 'error',
    ERROR_DESCRIPTION = 'error_description'
}

export enum SocialPageLoadType {
    STATE = 'state',
    DISCONNECT = 'disconnect',
    CONNECT = 'connect'
}

export const STATE_DIVIDER = '|';
